import React, { FC } from 'react';
import s from './counter.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import cn from 'classnames';
interface Props {
  count: number;
  countHandler: (variant: boolean) => void;
  className?: string;
  disabled?: boolean;
}
export const Counter: FC<Props> = ({
  count,
  countHandler,
  className,
  disabled
}) => <div className={cn(s.counter, className)} data-sentry-component="Counter" data-sentry-source-file="Counter.tsx">
        <Button id='default_button' className={s.counter__button} size={'small'} color={'White'} onClick={() => countHandler(false)} disabled={count === 1 || disabled} data-sentry-element="Button" data-sentry-source-file="Counter.tsx">
            <SpriteIcon name={'minus'} data-sentry-element="SpriteIcon" data-sentry-source-file="Counter.tsx" />
        </Button>
        <div className={s.counter__count}>{count}</div>
        <Button id='default_button' className={s.counter__button} size={'small'} color={'White'} onClick={() => countHandler(true)} disabled={disabled} data-sentry-element="Button" data-sentry-source-file="Counter.tsx">
            <SpriteIcon name={'plus'} data-sentry-element="SpriteIcon" data-sentry-source-file="Counter.tsx" />
        </Button>
    </div>;